import { defineComponent as _defineComponent } from 'vue'
import { ref, provide, inject, Ref } from 'vue';
import { HelperViewStatus, LoaderIndicator } from '@warrenbrasil/nebraska-web';
import { AboutStrategy } from './components/AboutStrategy';
import { AboutLinks } from './components/AboutLinks';
import { AboutDetails } from './components/AboutDetails';
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { DetailModal } from '@/modules/wealth/components/DetailModal';
import { IDetailModalProps } from '@/modules/wealth/types';
import { Portal } from '@/modules/common/components/Portal';
import { DeletePortfolioModal } from './components/DeletePortfolioModal';
import { RenamePortfolioModal } from './components/RenamePortfolioModal';
import { ChangePortfolioBackgroundModal } from './components/ChangePortfolioBackgroundModal';
import { AboutRedemption } from './components/AboutRedemption';

interface Props {
  portfolioId: string;
  fetchPortfolioDetails: (reloadCause: string) => void;
  hasError: boolean;
  isCustom: boolean;
  isFixedIncomePortfolioType: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    portfolioId: null,
    fetchPortfolioDetails: null,
    hasError: { type: Boolean },
    isCustom: { type: Boolean },
    isFixedIncomePortfolioType: { type: Boolean }
  },
  setup(__props: any) {


const showRenamePortfolioModal = ref(false);
const showChangeBackgroundModal = ref(false);
const showDeleteModal = ref(false);
const showDetailModal = ref(false);
const detailModalProps = ref<IDetailModalProps>({
  title: '',
  type: ''
});
const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  inject<IPortfolioDistributionResponse>('portfolioDistribution')
);
const isPortfolioDistributionLoading = inject(
  'isPortfolioDistributionLoading'
) as Ref<boolean>;

function openDetailModal(detailModalParam: IDetailModalProps) {
  detailModalProps.value = detailModalParam;
  showDetailModal.value = true;
}

provide('closeDetailModal', () => (showDetailModal.value = false));

return { __sfc: true,showRenamePortfolioModal, showChangeBackgroundModal, showDeleteModal, showDetailModal, detailModalProps, portfolioDistribution, isPortfolioDistributionLoading, openDetailModal, HelperViewStatus, LoaderIndicator, AboutStrategy, AboutLinks, AboutDetails, DetailModal, Portal, DeletePortfolioModal, RenamePortfolioModal, ChangePortfolioBackgroundModal, AboutRedemption }
}

})